import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Notification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { Role } from '../../models/shared/role.model';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NotificationRole } from '../../models/notification/notificationRole.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-edit-notification',
    templateUrl: './edit-notification.component.html',
    styleUrls: ['./edit-notification.component.css']
})
/** edit-notification component*/
export class EditNotificationComponent {
  public notification = new Notification();
  public customerTypes: Role[];
  public notificationEvents: NotificationEvent[];
  public bellIcon: any;
  public notificationTypes: string[];
  form: FormGroup;
  frm: FormGroup;
  IconfileToUpload: File;
  fileToUpload: File;
  selectedSmallImage: string = "";
  selectedTinyImage: string = "";
  selectedTinLogo: string = "";
  icons: string[] = [];
  images: string[] = [];
  public controls: FormControl[]=[];
  public notificationControls: FormControl[]=[];
  roles = [];
  types = [];
  public inputElement: any;
  public notificationRoleList: NotificationRole[] = [];
  public notificationRoles: NotificationRole[];

  //public startDateElement: any;
  //public endDateElement: any;
    /** edit-notification ctor */
  constructor(private _avRoute: ActivatedRoute,
    private notificationService: NotificationService, private _router: Router,
    private formBuilder: FormBuilder, private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetNotificationEvents();
    this.GetCustomerRoles();
    // for mulitple Dynamic checkeboxes
    // For roles
    this.controls = this.roles.map(c => new FormControl(false));
    //this set to default checked
    //if (this.roles.length > 0) {
    //  this.controls[0].setValue(true);
    //}
    this.form = this.formBuilder.group({
      roles: new FormArray(this.controls, minSelectedCheckboxes(1))
    });
    // For Notification Types
    this.notificationControls = this.types.map(c => new FormControl(false));
    //this set to default checked
    //if (this.types.length > 0) {
    //  this.notificationControls[0].setValue(true);
    //}
    this.frm = this.formBuilder.group({
      types: new FormArray(this.notificationControls, minSelectedCheckboxes(1))
    });

    if (this._avRoute.snapshot.params["id"]) {
      this.notificationService.GetNotificationById(this._avRoute.snapshot.params["id"]).subscribe(
        data => {
          this.notification = data;
          this.notification.isImage = false;
          this.notification.isIcon = false;
          // For Notification Types
          this.notificationService.GetNotificationTypes().subscribe(
            data => {
              this.notificationTypes = data;
              for (var i = 0; i < this.notificationTypes.length; i++) {
                this.types.push({
                  'id': this.notificationTypes[i],
                  'name': this.notificationTypes[i]
                });
              }
              //this set to default checked
              const arrTypes = this.notification.notificationType.split(',');
              if (arrTypes.length > 0) {
                this.notificationControls = this.types.map(c => arrTypes.findIndex(s => s == c.id) >= 0 ? new FormControl(true) : new FormControl(false));
              } else {
                this.notificationControls = this.types.map(c => new FormControl(false));
              }

              this.frm = this.formBuilder.group({
                types: new FormArray(this.notificationControls, minSelectedCheckboxes(1))
              });
            });

          // For roles
          this.notificationService.GetCustomerTypes().subscribe(
            data => {
              this.customerTypes = data;
              for (var i = 0; i < this.customerTypes.length; i++) {
                this.roles.push({
                  'id': this.customerTypes[i].roleID,
                  'name': this.customerTypes[i].roleName
                });
              }
              //this set to default checked
              // getting roles list based on notification
              this.notificationService.GetNotificationRolesByNotificationID(this.notification.notificationID).subscribe(
                data => {
                  this.notificationRoles = data;
                  //this set to default checked
                  this.controls = this.roles.map(c => this.notificationRoles.findIndex(s => s.roleID == c.id) >= 0 ? new FormControl(true) : new FormControl(false));

                  this.form = this.formBuilder.group({
                    roles: new FormArray(this.controls, minSelectedCheckboxes(1))
                  });
                  setTimeout(() => {
                    for (var i = 0; i < this.notificationRoles.length; i++) {
                      if (this.notificationRoles[i].isAction) {
                        let fieldname = "input-" + this.notificationRoles[i].roleID;
                        this.inputElement = document.getElementById(fieldname) as HTMLElement;
                        this.inputElement.value = this.notificationRoles[i].action;
                      }

                    }
                  }, 2000);
                
                });

            });
        });
    }
  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.images.push(e.target.result);
      this.notification.image = this.images[0];
      this.selectedSmallImage = this.images[0];
      this.notification.isImage = true;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadTinyImage(file: FileList) {
    this.IconfileToUpload = file.item(0);
    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.icons.push(e.target.result);
      this.notification.icon = this.icons[0];
      this.selectedTinyImage = this.icons[0];
      this.notification.isIcon = true;
    }
    reader.readAsDataURL(this.IconfileToUpload);
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("notification").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
          }
          else {
            this._router.navigate(["/notification-list"]);
          }
        }
        else {
          this._router.navigate(["/notification-list"]);
        }
      }
    )
  }
  GetCustomerRoles() {
    this.notificationService.GetCustomerTypes().subscribe(
      data => {
        this.customerTypes = data;
      }
    )
  }
  GetNotificationEvents() {
    this.notificationService.GetNotificationActiveEvents().subscribe(
      data => {
        this.notificationEvents = data;
      }
    )
  }
  

  onSubmit() {
    
    //getting checkbox values
    const selectedRoleIds = this.form.value.roles
      .map((v, i) => v ? this.roles[i].id : null)
      .filter(v => v !== null);
    //getting checkbox values
    const selectedNotificationIds = this.frm.value.types
      .map((v, i) => v ? this.types[i].id : null)
      .filter(v => v !== null);

    //Insert Notification
    let type: string = "";
    for (var i = 0; i < selectedNotificationIds.length; i++) {
      type += "," + selectedNotificationIds[i];
    }
    this.notification.notificationType = type.substring(1);
    this.notificationService.UpdateNotification(this.notification);
    // update Notification Roles
    const notificationID = this.notification.notificationID;
    //Insert Notification Role
    for (var i = 0; i < selectedRoleIds.length; i++) {
      const notificationRole = new NotificationRole();
      notificationRole.roleID = selectedRoleIds[i];
      notificationRole.notificationID = notificationID;
      // check Action values against each role
      let fieldname = "input-" + selectedRoleIds[i];
      this.inputElement = document.getElementById(fieldname) as HTMLElement;
      if (this.inputElement.value != "") {
        notificationRole.action = this.inputElement.value;
        notificationRole.isAction = true;
      }
      this.notificationRoleList.push(notificationRole);
    }
    if (selectedRoleIds.length == 0) {
      const notificationRole = new NotificationRole();
      notificationRole.roleID = 0;
      notificationRole.notificationID = notificationID;
      this.notificationRoleList.push(notificationRole);
    }
    this.notificationService.AddNotificationRole(this.notificationRoleList);
    this.toastr.success('Notification updated successfully.', 'Success');
  }

}
//For Dynamic Checkboxes
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}



// WEBPACK FOOTER //
// ./src/app/notification-components/edit-notification/edit-notification.component.ts